
import { computed, defineComponent, onMounted, ref, provide } from 'vue';
import axios from 'axios'
import { useStore } from '../store/index'
import { useRouter } from 'vue-router'
import { use } from "echarts/core"
import { CanvasRenderer } from "echarts/renderers"
import { LineChart } from "echarts/charts"
import { reverse } from 'lodash-es'
import dayjs from 'dayjs'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts"

export default defineComponent({
  name: 'Home',
  components: {
    VChart
  },
  setup() {
    use([
      CanvasRenderer,
      LineChart,
      TitleComponent,
      TooltipComponent,
      GridComponent,
      LegendComponent
    ])
    provide(THEME_KEY, "light")
    const date = ref<null | string[]>(null)
    const isTotal = ref(false)
    let cacheFinalData: any =  {}
    const option = ref<any>({
      title: {
        text: "简单简历统计",
        left: "center"
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/> {b} : {c}"
      },
      legend: {
        orient: "vertical",
        left: "left",
        data: []
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      series: [
      ]
    })
    const store = useStore()
    const router = useRouter()
    const user = computed(() => store.state.user)
    const logout = () => {
      axios.get('/api/logout').then(() => {
        store.commit('logout')
        router.push('/login')
        window.location.reload()
      })
    }
    const dataRange = computed(() => {
    if (Array.isArray(date.value)) {
      return date.value.map(item => dayjs(item).format('YYYY-MM-DD') )
    }
      return ['', '']
    })
    const reRenderChart = (finalData: any) => {
      // 显示的时候要减一天，因为这个日期指的是生成日期
      const dateArr = finalData.map(data => dayjs(data.date).add(-1, 'days').format('YYYY-MM-DD'))
      const resumeArr = finalData.map(data => isTotal.value ? data.data.resume.all : data.data.resume.increase)
      const orderArr = finalData.map(data => isTotal.value ? data.data.order.all :data.data.order.increase)
      const userArr = finalData.map(data => isTotal.value ? data.data.user.all : data.data.user.increase)
      option.value.xAxis.data = dateArr
      // clear the data
      option.value.series = []
      option.value.series.push({ name: '订单', data: orderArr, type: 'line' })
      option.value.series.push({ name: '简历', data: resumeArr, type: 'line' })
      option.value.series.push({ name: '用户', data: userArr, type: 'line' })
      option.value.legend.data =  ["订单", "简历", "用户"]
    }

    const generateSalesChart = async (startDate: string, endDate: string, pageSize = 10) => {
      const { data } = await axios.get(`/api/sales?startDate=${startDate}&endDate=${endDate}&pageSize=${pageSize}`)
      const finalData = reverse(data.data.data)
      cacheFinalData = finalData
      reRenderChart(finalData)
    }

    const genereateNewChart = async () => {
      if (dataRange.value) {
        const pageSize = dayjs(dataRange.value[1]).diff(dayjs(dataRange.value[0]), "day")
        console.log(pageSize)
        await generateSalesChart(dataRange.value[0], dataRange.value[1], pageSize > 60 ? 60 : pageSize)
      }
    }
    const switchMode = () => {
      reRenderChart(cacheFinalData)
    }
    onMounted(async () => {
      const endDate = dayjs().format('YYYY-MM-DD')
      const startDate = dayjs().add(-7, 'day').format('YYYY-MM-DD')
      await generateSalesChart(startDate, endDate)
    })
    return {
      user,
      logout,
      option,
      date,
      genereateNewChart,
      isTotal,
      switchMode
    }
  }
});
